import Typewriter from 'typewriter-effect/dist/core';

export default function InitHeroAnimations() {
    InitHeadlineAnimation();
}

function InitHeadlineAnimation() {
    const headlineWrapper = document.querySelector('.hero-headlines');
    if (!headlineWrapper) return;

    const headlines = headlineWrapper.querySelectorAll('.headline');
    const cursor = headlineWrapper.querySelector('.hero-headlines .cursor');

    // Get strings out of headline elements and remove all except the first
    const headlineStrings = Array.from(headlines).map((headline) => headline.textContent);
    headlines.forEach((headline, i) => i > 0 ? headline.remove() : headline);

    const headline = headlineWrapper.querySelector('.headline');

    const typewriterEffect = new Typewriter(headline, {
        strings: headlineStrings,
        cursor: '_',
        autoStart: true,
        loop: true,
    });
}